import SearchBar from './search-bar/search-bar';
import WebResults from './web-results/web-results';
import FeedbackModal from './feedback-modal/feedback-modal';
import Ricola from 'ricola3';
import rcTableController from 'ricola3';
import rcInfiniteScroll from 'ricola3';
import 'ng-infinite-scroll';

export default angular.module('searchEngineFrontend.searchInterface.shared.components', 
    [
        'infinite-scroll'
    ])
    .component('searchBar', SearchBar)
    .component('webResults', WebResults)
    .component('feedbackModal', FeedbackModal);
    
angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);



// WEBPACK FOOTER //
// ./src/search-interface/shared/components/index.js